import { useUrlParam } from "@opendash/core";
import { $parse, ParseFilterState, ParseSetView } from "@opendash/plugin-parse";
import { Drawer, DrawerProps } from "antd";
import React from "react";
type ActiveOrderDrawerProps = React.PropsWithChildren &
  DrawerProps & {
    orderNrOverwrite?: string;
  };
const ActiveOrderDrawer = (props: ActiveOrderDrawerProps) => {
  const { orderNrOverwrite = undefined, height = "66%" } = props;

  const [planId, setPlanId] = useUrlParam<string | undefined>(
    "orderId",
    orderNrOverwrite,
    "string"
  );
  const state = React.useMemo(() => {
    const view = $parse.ui.defaultViewMap["OD3_MES_Order"];
    const newState = new ParseFilterState("OD3_MES_Order", view, false);
    newState.setPageSize(1000);
    newState.setCustomQuery((query) => {
      query.equalTo("ordernr", planId);
    });

    return newState;
  }, [planId]);

  return (
    <Drawer
      style={{ padding: 0 }}
      placement="bottom"
      height={height}
      open={!!planId}
      {...props}
      onClose={(e) => {
        setPlanId(undefined);
        if (props.onClose) props.onClose(e);
      }}
    >
      <ParseSetView state={state} className="OD3_MES_Order" />
    </Drawer>
  );
};

export default ActiveOrderDrawer;
export type { ActiveOrderDrawerProps };
